import { get } from "../GenericServices";

const ExportProjectTask = {
  exportSap: (queryString) => {
    return get(`export-project-task/find?${queryString}`);
  },
  getSuppliersExportSap: (queryString) => {
    return get(`export-project-task/suppliers?${queryString}`);
  },
};

export default ExportProjectTask;
